/**
 * Free People Brand Switch Header
 * Handles brand tab switching, mobile drawer, and sticky behavior
 */
(function () {
  'use strict';

  class FPHeader {
    constructor(el) {
      this.el = el;
      this.init();
    }

    init() {
      this.tabs = this.el.querySelectorAll('.fp-brand-tabs__tab');
      this.navs = this.el.querySelectorAll('.fp-nav');
      this.menuBtn = this.el.querySelector('.fp-icon-btn--menu');
      this.drawer = this.el.querySelector('.fp-mobile-drawer');
      this.overlay = this.el.querySelector('.fp-mobile-drawer__overlay');
      this.closeBtn = this.el.querySelector('.fp-mobile-drawer__close');
      this.mobileTabs = this.el.querySelectorAll('.fp-mobile-drawer__tab');
      this.mobileNavs = this.el.querySelectorAll('.fp-mobile-nav');
      this.toggles = this.el.querySelectorAll('.fp-mobile-nav__toggle');

      this.bindEvents();
      this.enableNavScroll();
      
      // Fix: Automatically append URL parameters to all nested dropdown links
      this.patchLinks();

      // Determine correct brand on page load and apply immediately
      const initialBrand = this.determineInitialBrand();
      this.brand = initialBrand;
      this.applyBrandState(initialBrand);
      this.forceBrandOnPageLoad();
    }
    forceBrandOnPageLoad() {
  const url = new URL(window.location.href);
  const param = url.searchParams.get('brand-switch');
  const stored = sessionStorage.getItem('fpActiveBrand');

  // If URL has NO param but session has → FIX URL
  if (!param && stored !== null) {
    url.searchParams.set('brand-switch', stored);

    // Update URL WITHOUT reload loop
    window.history.replaceState({}, '', url);

    // Apply correct brand immediately
    this.applyBrandState(+stored);
  }
}

patchLinks() {
  const applyBrandToLinks = () => {
    const currentBrand = sessionStorage.getItem('fpActiveBrand') || this.brand || 0;

    document.querySelectorAll('a').forEach(link => {
      try {
        const href = link.getAttribute('href');

        // Skip invalid links
        if (!href || href.startsWith('#') || href.startsWith('javascript')) return;

        const url = new URL(link.href, window.location.origin);

        // Only internal links
        if (url.origin === window.location.origin) {
          url.searchParams.set('brand-switch', currentBrand);
          link.href = url.pathname + url.search + url.hash;
        }
      } catch (e) {}
    });
  };

  // Run initially
  applyBrandToLinks();

  // 🔥 Run again when user clicks ANY link (important)
  document.addEventListener('click', () => {
    applyBrandToLinks();
  });
}

determineInitialBrand() {
  // PRIORITY 1: sessionStorage (MOST IMPORTANT)
  const stored = sessionStorage.getItem('fpActiveBrand');
  if (stored !== null && !isNaN(stored)) {
    return +stored;
  }

  // PRIORITY 2: URL param
  const p = new URLSearchParams(window.location.search);
  const b = p.get('brand-switch');
  if (b !== null && !isNaN(b)) {
    return +b;
  }

  return 0;
}

    applyBrandState(index) {
      // Save state to browser memory
      sessionStorage.setItem('fpActiveBrand', index);
      this.el.setAttribute('data-active-brand', index);

      // Update Tabs visually
      this.tabs.forEach((t, i) => t.classList.toggle('fp-brand-tabs__tab--active', i === index));
      this.mobileTabs.forEach((t, i) => t.classList.toggle('fp-mobile-drawer__tab--active', i === index));

      // Show Nav without animation on initial load
      this.navs.forEach((n, i) => {
        n.classList.remove('fp-nav--entering', 'fp-nav--leaving');
        if (i === index) {
          n.classList.add('fp-nav--active');
        } else {
          n.classList.remove('fp-nav--active');
        }
      });

      // Update Mobile Navs
      this.mobileNavs.forEach((n, i) => n.classList.toggle('fp-mobile-nav--active', i === index));
    }

    bindEvents() {
      // Brand tab clicks
      this.tabs.forEach(tab => {
        tab.addEventListener('click', e => {
          e.preventDefault();
          this.switchBrand(+tab.dataset.brandIndex);
        });
      });

      // Mobile brand tabs
      this.mobileTabs.forEach(tab => {
        tab.addEventListener('click', () => this.switchBrand(+tab.dataset.brandIndex));
      });

      // Mobile drawer
      if (this.menuBtn) this.menuBtn.addEventListener('click', () => this.openDrawer());
      if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.closeDrawer());
      if (this.overlay) this.overlay.addEventListener('click', () => this.closeDrawer());

      // Mobile sub toggles
      this.toggles.forEach(btn => {
        btn.addEventListener('click', e => {
          e.preventDefault();
          const sub = btn.nextElementSibling;
          const isOpen = sub.classList.contains('is-open');
          // Close others
          this.toggles.forEach(b => {
            if (b !== btn && b.nextElementSibling) {
              b.nextElementSibling.classList.remove('is-open');
              b.classList.remove('is-open');
            }
          });
          sub.classList.toggle('is-open', !isOpen);
          btn.classList.toggle('is-open', !isOpen);
        });
      });

      // Escape key
      document.addEventListener('keydown', e => {
        if (e.key === 'Escape') this.closeDrawer();
      });
      document.addEventListener('click', (e) => {
  const link = e.target.closest('a');
  if (!link) return;

  const href = link.getAttribute('href');
  if (!href || href.startsWith('#') || href.startsWith('javascript')) return;

  try {
    const url = new URL(link.href, window.location.origin);

    // Only internal links
    if (url.origin !== window.location.origin) return;

    const currentBrand = sessionStorage.getItem('fpActiveBrand') || this.brand || 0;

    // Inject param BEFORE navigation happens
    url.searchParams.set('brand-switch', currentBrand);

    // Override navigation
    e.preventDefault();
    window.location.href = url.pathname + url.search + url.hash;

  } catch (err) {}
});
    }

    enableNavScroll() {
      this.navs.forEach(nav => {
        nav.addEventListener('wheel', event => {
          if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {
            nav.scrollLeft += event.deltaY;
            event.preventDefault();
          }
        }, { passive: false });
      });
    }

    switchBrand(index) {
      if (index === this.brand) return;
      const prev = this.brand;
      this.brand = index;

      // Update state data in browser memory
      sessionStorage.setItem('fpActiveBrand', index);
      this.el.setAttribute('data-active-brand', index);

      // Tabs
      this.tabs.forEach((t, i) => t.classList.toggle('fp-brand-tabs__tab--active', i === index));
      this.mobileTabs.forEach((t, i) => t.classList.toggle('fp-mobile-drawer__tab--active', i === index));

      // Desktop nav animation
      const from = prev >= 0 ? this.navs[prev] : null;
      const to = this.navs[index];

      if (from) {
        from.classList.remove('fp-nav--active');
        from.classList.add('fp-nav--leaving');
        from.addEventListener('animationend', () => from.classList.remove('fp-nav--leaving'), { once: true });
      }
      if (to) {
        to.classList.add('fp-nav--entering');
        to.addEventListener('animationend', () => {
          to.classList.remove('fp-nav--entering');
          to.classList.add('fp-nav--active');
        }, { once: true });
      }

      // Mobile nav
      this.mobileNavs.forEach((n, i) => n.classList.toggle('fp-mobile-nav--active', i === index));

      // Update URL silently so users can copy/paste it
      const url = new URL(window.location);
      url.searchParams.set('brand-switch', index);
      window.history.replaceState({}, '', url);
    }

    openDrawer() {
      this.drawer.setAttribute('aria-hidden', 'false');
      this.menuBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    closeDrawer() {
      if (!this.drawer) return;
      this.drawer.setAttribute('aria-hidden', 'true');
      if (this.menuBtn) this.menuBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
  }

  // Init
  function boot() {
    document.querySelectorAll('.fp-header').forEach(el => {
      if (!el._fp) el._fp = new FPHeader(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify Theme Editor support
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', e => {
      const el = e.target.querySelector('.fp-header');
      if (el) el._fp = new FPHeader(el);
    });
  }
})();